import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/ACCOUNT-ITEM-MOVE-MODAL';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (institutionId, billPayerId, accountItemType, accountItemId) => ({
        institutionId,
        billPayerId,
        accountItemType,
        accountItemId,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`);

export const {
    action: search,
    success: searchSuccess,
    failed: searchFailed,
    aborted: searchAborted,
} = createAction(`${domain}/SEARCH`, (institutionId, term) => ({institutionId, term}));

export const {
    action: moveInvoice,
    success: moveInvoiceSuccess,
    failed: moveInvoiceFailed,
    aborted: moveInvoiceAborted,
} = createAction(
    `${domain}/MOVE_INVOICE`,
    (institutionId, billPayerId, invoiceId, newBillPayerId, newBillPayerName) => ({
        institutionId,
        billPayerId,
        invoiceId,
        newBillPayerId,
        newBillPayerName,
    }),
);

export const {
    action: movePayment,
    success: movePaymentSuccess,
    failed: movePaymentFailed,
    aborted: movePaymentAborted,
} = createAction(
    `${domain}/MOVE_PAYMENT`,
    (institutionId, billPayerId, paymentId, newBillPayerId, newBillPayerName) => ({
        institutionId,
        billPayerId,
        paymentId,
        newBillPayerId,
        newBillPayerName,
    }),
);
